'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Newspaper = function Newspaper(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-newspaper ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13,8.80354989 L8.125,8.80354989 L8.125,13.6785499 L13,13.6785499 L13,8.80354989 Z M14.625,16.9285499 L14.625,18.5535499 L6.5,18.5535499 L6.5,16.9285499 L14.625,16.9285499 Z M14.625,7.17854989 L14.625,15.3035499 L6.5,15.3035499 L6.5,7.17854989 L14.625,7.17854989 Z M22.75,16.9285499 L22.75,18.5535499 L16.25,18.5535499 L16.25,16.9285499 L22.75,16.9285499 Z M22.75,13.6785499 L22.75,15.3035499 L16.25,15.3035499 L16.25,13.6785499 L22.75,13.6785499 Z M22.75,10.4285499 L22.75,12.0535499 L16.25,12.0535499 L16.25,10.4285499 L22.75,10.4285499 Z M22.75,7.17854989 L22.75,8.80354989 L16.25,8.80354989 L16.25,7.17854989 L22.75,7.17854989 Z M3.25,19.3660499 L3.25,7.17854989 L1.625,7.17854989 L1.625,19.3660499 C1.625,19.8103858 1.99316406,20.1785499 2.4375,20.1785499 C2.88183594,20.1785499 3.25,19.8103858 3.25,19.3660499 Z M24.375,19.3660499 L24.375,5.55354989 L4.875,5.55354989 L4.875,19.3660499 C4.875,19.6453468 4.82421875,19.9246436 4.73535156,20.1785499 L23.5625,20.1785499 C24.0068359,20.1785499 24.375,19.8103858 24.375,19.3660499 Z M26,3.92854989 L26,19.3660499 C26,20.711753 24.9082031,21.8035499 23.5625,21.8035499 L2.4375,21.8035499 C1.09179688,21.8035499 0,20.711753 0,19.3660499 L0,5.55354989 L3.25,5.55354989 L3.25,3.92854989 L26,3.92854989 Z' })
  );
};

Newspaper.propTypes = _bcPropTypes.iconShape;

exports.default = Newspaper;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Newspaper/Newspaper.js
// module id = 230
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14